import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {Link, useParams} from "react-router-dom";
import logo from "../../assets/images/vibe24-logo.png";
import {useDispatch, useSelector} from "react-redux";
import {fetchVendorDocument} from "../../store/vendor-slice";
import Table from "../../components/common/table/Table";
import {getVendorDocTableColumns, getVendorDocTableData} from "../../models/vendorModel";
import {fetchVendorListForVendorDoc} from "../../store/list-slice";

const VendorDocHistory = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const list = useSelector(state => state.list);
    const {items: vendors = {}} = list.vendorListDoc;

    const {
        vendorUploadedDoc: items,
        fetchVendorDocStatus,
        docHistoryPagination: pagination,
        documentFetchError
    } = useSelector(state => state.vendor);

    useEffect(() => {
        dispatch(fetchVendorDocument({scopeId: params.scopeId, vendorId: params.vendorId}))
    }, [dispatch, params.scopeId, params.vendorId]);

    const tableColumns = getVendorDocTableColumns();
    const tableData = getVendorDocTableData({items});

    useEffect(() => {
        dispatch(fetchVendorListForVendorDoc({scopeId: params.scopeId}));
    }, [dispatch, params.scopeId]);

    const vendorName = vendors[params.vendorId]?.toUpperCase() || '';

    function calculateTotals(data = []) {
        const result = { totalAmount: 0, paidAmount: 0, dueAmount: 0 };

        data.forEach(item => {
            result.totalAmount += Number(item?.totalAmount) || 0;
            result.paidAmount += Number(item?.totalPayment) || 0;
            result.dueAmount += Number(item?.dueAmount) || 0;
        });

        return result;
    }

    const { totalAmount, paidAmount, dueAmount } = calculateTotals(items);

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-5">
                <Link to=""><img src={logo} alt="logo" height={60} width={120}/></Link>
                <span className="fs-md align-middle bg-dark px-2 rounded-pill text-white py-1 px-4">{vendorName}</span>
            </div>

            <div className="border rounded-3 p-5 bg-white">
                <SubHeader title="Payment History">
                    <Button to="../docUpload" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
                </SubHeader>

                {fetchVendorDocStatus === "loading" && <p>Loading...</p>}
                {fetchVendorDocStatus === "failed" && <h6 className="text-danger">{documentFetchError}</h6>}
                {fetchVendorDocStatus === "success" && (
                    <>
                        {(items && items.length === 0) && <p>No Data found.</p>}
                        <div className="d-flex flex-wrap gap-3 mb-5">
                            <span className="border border-dark px-2 rounded-pill text-dark">Total Amount : ₹ {totalAmount} /-</span>
                            <span className="border border-info px-2 rounded-pill text-info">Paid Amount : ₹  {paidAmount} /-</span>
                            <span className="border border-danger px-2 rounded-pill text-danger">Due Amount : ₹ {dueAmount} /-</span>
                        </div>
                        <Table
                            className="mobile-responsive"
                            columns={tableColumns}
                            data={tableData}
                            pagination={pagination}
                        />
                    </>
                )}
            </div>
        </>
    )
}

export default VendorDocHistory